export enum MAGIC_BOX_COMPONENTS {
    VISITS = 'visits',
    MEDICAL_HISTORY = 'mh',
    VITALS = 'vitals',
    MEDICAL_RECORDS = 'mr',
}
